import { Components, Theme } from '../../material';

export const MuiSvgIcon: Components<Theme>['MuiSvgIcon'] = {
  variants: [
    {
      props: { fontSize: 'xSmall' },
      style: {
        fontSize: '1.2rem', // 12px
        svg: {
          strokeWidth: 1.8,
        },
      },
    },
    {
      props: { fontSize: 'small' },
      style: {
        fontSize: '1.6rem', // 16px
        svg: {
          strokeWidth: 1.6,
        },
      },
    },
    {
      props: { fontSize: 'medium' },
      style: {
        fontSize: '2rem', // 20px
        svg: {
          strokeWidth: 1.5,
        },
      },
    },
    {
      props: { fontSize: 'large' },
      style: {
        fontSize: '2.4rem', // 24px
        svg: {
          strokeWidth: 1.35,
        },
      },
    },
    {
      props: { fontSize: 'xLarge' },
      style: {
        fontSize: '3.2rem', // 32px
        svg: {
          strokeWidth: 1.2,
        },
      },
    },
    {
      props: { fontSize: 'xxLarge' },
      style: {
        fontSize: '6.4rem', // 64px
        svg: {
          strokeWidth: 0.75,
        },
      },
    },
  ],
};
